import { DeferHandler } from './defer-handler.js';
/**
 * A Defer Handler to allow a component to be initialized if the following
 *  conditions are met.  The defer handler looks for 2 data attributes on
 *  the component:
 *    data-defer-condition-type: The type of Conditional to be evaluated
 *    data-defer-condition The condition to be evaluated
 *
 *  1. If the condition type is boolean, the condition will be evaluated, and if true,
 *    the Promise will be resolved
 *
 */
export class ConditionalDeferHandler extends DeferHandler {
    setHandler() {
        return new Promise((resolve) => {
            const conditionType = this.component.getAttribute('data-defer-condition-type');
            const condition = this.component.getAttribute('data-defer-condition');
            if (conditionType === 'boolean') {
                if (condition == 'true' || JSON.parse(condition)) {
                    resolve();
                }
            }
        });
    }
}
//# sourceMappingURL=conditional-defer-handler.js.map